<template>
  <SidebarLayout>
    <!-- Sidebar -->
    <template v-slot:sidebar="{ sidebar }">
      <div class="d-flex flex-column my-4">
        <v-btn v-for="item in menu" :key="item.tab" text :block="sidebar" @click="tab = item.tab" :icon="!sidebar" color="white" :title="item.title" :class="['mb-4', sidebar ? 'left-align-btn' : 'mx-auto']">
          <v-icon :left="sidebar">{{ item.icon }}</v-icon> <span v-if="sidebar">{{ item.title }}</span>
        </v-btn>
      </div>
    </template>
    <!-- Main -->
    <template v-slot:main>
      <v-alert type="info" tile flat>
        GAME: {{ game.id }}
      </v-alert>
      <GameCreator v-if="tab === 0" :game="game" />
      <GamePreview v-if="tab === 1" :game="game" />
      <GameCode v-if="tab === 2" :game="game" />
      <GameDebug v-if="tab === 3" :game="game" />
      <GameAssets v-if="tab === 4" />
      <GameSettings v-if="tab === 5" />
      <GameDocument v-if="tab === 6" :id="(game && game.id) ? game.id : ($route && $route.params && $route.params.id)" />
    </template>
  </SidebarLayout>
</template>

<script>
import SidebarLayout from '@/layouts/Sidebar.vue'
import GameCreator from '@/components/games/GameCreator.vue'
import GamePreview from '@/components/games/GamePreview.vue'
import GameCode from '@/components/games/GameCode.vue'
import GameDebug from '@/components/games/GameDebug.vue'
import GameAssets from '@/components/games/GameAssets.vue'
import GameSettings from '@/components/games/GameSettings.vue';
import GameDocument from '@/components/games/GameDocument.vue';

import { doc, getDoc } from 'firebase/firestore';
import { db } from '@/firebase/init'

export default {

  name: 'RealmGame',

  components: {
    SidebarLayout,
    GameCreator,
    GamePreview,
    GameCode,
    GameDebug,
    GameAssets,
    GameSettings,
    GameDocument,
  },

  data() {
    return {
      tab: 0,
      game: null,
      loading: false,
      menu: [
        { title: 'Creator', icon: 'mdi-creation', tab: 0 },
        { title: 'Preview', icon: 'mdi-controller', tab: 1 },
        { title: 'Code', icon: 'mdi-code-braces', tab: 2 },
        { title: 'Debug', icon: 'mdi-bug-outline', tab: 3 },
        { title: 'Assets', icon: 'mdi-image-outline', tab: 4 },
        { title: 'Settings', icon: 'mdi-cog-outline', tab: 5 },
        { title: 'Document', icon: 'mdi-file-document-outline', tab: 6 },
      ],
    }
  },

  methods: {

    intitialize() {
      // Load the game from Firestore or Create a new one
      this.loading = true;
      let gameId = this.$route.params.id;
      if (gameId) {
        this.loadGame(gameId);
      }
    },

    loadGame(gameId) {
      // Load the game from Firestore
      const gameRef = doc(db, 'games', gameId);
      getDoc(gameRef).then((doc) => {
        this.game = doc.data();
        this.game.id = doc.id;
        this.loading = false;
      });
    },

    playGame() {
      if (this.game && this.game.id) {
        this.$router.push({ name: 'GamePlayer', params: { id: this.game.id } });
      }
    },

    displayTab(tab) {
      this.tab = tab;
    },

  },

  mounted() {
    this.intitialize()
  }
}
</script>
<style lang="scss">
  .left-align-btn {
    justify-content: flex-start !important;
  }
</style>
